import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';
// import * as $ from 'jquery';
export default class Register {
  constructor() {
    document
      .querySelector('#register_screen #registerBtn')
      .addEventListener('click', this.onRegisterSubmit.bind(this, false));

    document
      .querySelector('#register_screen .terms_trigger')
      .addEventListener('click', () => {
        $('#tncModal').modal('show');
      });
    document.querySelector('#tCClose').addEventListener('click', () => {
      $('#tncModal').modal('hide');
    });
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.termsAccepted = false;
    this.registered = false;
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
      case 'hide_screen':
        this.hideScreen(data['message']['data']);
        break;
    }
  }
  //   updateTermsStatus() {
  //     this.termsAccepted = !this.termsAccepted;

  //     if (this.termsAccepted) {
  //       document.querySelector('#t_c_check').classList.add('active');
  //       document
  //         .querySelector('#register_screen .checkbox')
  //         .classList.remove('error');
  //     } else {
  //       document.querySelector('#t_c_check').classList.remove('active');
  //     }
  //   }
  async showScreen(data) {
    if (data['screenKey'] !== 'Register') return false;

    // const result= await register("John", "John@gmail.com", "8105106261",  "karnataka");
    // this.showNextScreen();
    // return false;

    this.registered = false;
    this.termsAccepted = false;
    // document.querySelector('#t_c_check').classList.remove('active');
    document.querySelector('#register_screen #name').value = '';
    document.querySelector('#register_screen #mobile').value = '';
    // document.querySelector('#register_screen #email').value = '';
    // document.querySelector('#register_screen #location').value = '';
    // document.querySelector('#register_screen #ig_handle').value = '';

    if (localStorage.getItem('userName')) {
      document.querySelector('#register_screen #name').value =
        localStorage.getItem('userName');
      document.querySelector('#register_screen #mobile').value =
        localStorage.getItem('mobile');
      // document.querySelector('#register_screen #email').value =
      //   localStorage.getItem('email');
      // document.querySelector('#register_screen #location').value =
      //   localStorage.getItem('location');
      // document.querySelector('#register_screen #ig_handle').value =
      //   localStorage.getItem('IGHandle');
    }

    document.querySelector('#register_screen').classList.add('active');
    gsap.delayedCall(0.1, () => {
      document.querySelector('#register_screen').classList.add('active2');
    });
    this.animateScreen();
  }
  animateScreen() {
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#register_screen .contents .title')
        .classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#register_screen .contents .field:nth-child(1)')
        .classList.add('active');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#register_screen .contents .field:nth-child(2)')
        .classList.add('active');
    });
    gsap.delayedCall(0.4, () => {
      document
        .querySelector('#register_screen .contents .field:nth-child(3)')
        .classList.add('active');
    });
    gsap.delayedCall(0.5, () => {
      document
        .querySelector('#register_screen .contents .field:nth-child(4)')
        .classList.add('active');
    });
    gsap.delayedCall(0.6, () => {
      document
        .querySelector('#register_screen .contents .field:nth-child(5)')
        .classList.add('active');
    });
    gsap.delayedCall(0.7, () => {
      document
        .querySelector('#register_screen .contents .register_term_sec')
        .classList.add('active');
    });
    gsap.delayedCall(0.8, () => {
      document
        .querySelector('#register_screen .btn_container')
        .classList.add('active');
    });
    gsap.delayedCall(0.9, () => {
      document
        .querySelector('#register_screen .footer')
        .classList.add('active');
    });
  }
  async onRegisterSubmit() {
    if (this.registered) return false;

    let isValid = this.validate();

    if (!isValid) return false;

    this.registered = true;

    localStorage.setItem('userName', Global.userName);
    localStorage.setItem('mobile', Global.mobile);
    // localStorage.setItem('email', Global.email);
    // localStorage.setItem('location', Global.location);
    // localStorage.setItem('IGHandle', Global.IGHandle);

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'registerClick',
      uniqID: Global.U_ID,
    });
    Global.serverObj.send(Global.URL_DATA, null, null, {
      saveType: 'register',
      name: Global.userName,
      mobile: Global.mobile,
      // email: Global.email,
      // location: Global.location,
      // IGhandle: Global.IGHandle,
      uniqID: Global.U_ID,
    });

    this.showNextScreen();
    return;
    // const result = await register(
    //   Global.userName,
    //   Global.email,
    //   Global.mobile,
    //   Global.state
    // );

    if (result.statusCode !== 200) {
      document
        .querySelector('#register_screen #name')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #mobile')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #email')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #location')
        .parentElement.classList.remove('error');
      document
        .querySelector('#register_screen #ig_handle')
        .parentElement.classList.remove('error');

      this.registered = false;
      //totalLimitExceeded

      if (result.messageId === 'invalidName') {
        document
          .querySelector('#register_screen #name')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidMobile') {
        document
          .querySelector('#register_screen #mobile')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidEmail') {
        document
          .querySelector('#register_screen #email')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidLocation') {
        document
          .querySelector('#register_screen #location')
          .parentElement.classList.add('error');
      }
      if (result.messageId === 'invalidIGHandle') {
        document
          .querySelector('#register_screen #ig_handle')
          .parentElement.classList.add('error');
      }
      document.querySelector('.errorSec').innerHTML = result.message;
      document.querySelector('.errorSec').classList.add('active');
      this.errorTO && clearTimeout(this.errorTO);
      this.errorTO = setTimeout(() => {
        document.querySelector('.errorSec').classList.remove('active');
      }, 1000);
      return false;
    }

    this.showNextScreen();
  }
  validate() {
    let isValid = true;
    Global.userName = document
      .querySelector('#register_screen #name')
      .value.trim();
    Global.mobile = document
      .querySelector('#register_screen #mobile')
      .value.trim();
    // Global.email = document
    //   .querySelector('#register_screen #email')
    //   .value.trim();
    // Global.location = document
    //   .querySelector('#register_screen #location')
    //   .value.trim();
    // Global.IGHandle = document
    //   .querySelector('#register_screen #ig_handle')
    //   .value.trim();
    if (Global.userName.length == 0) {
      document
        .querySelector('#register_screen #name')
        .parentElement.classList.add('error');
      isValid = false;
      document.querySelector('.errorSec').innerHTML = 'Invalid Full Name.';
    } else {
      document
        .querySelector('#register_screen #name')
        .parentElement.classList.remove('error');
    }
    if ((Global.mobile.length == 0 || isNaN(Global.mobile)) && isValid) {
      document
        .querySelector('#register_screen #mobile')
        .parentElement.classList.add('error');
      isValid = false;
      document.querySelector('.errorSec').innerHTML = 'Invalid Mobile Number.';
    } else {
      document
        .querySelector('#register_screen #mobile')
        .parentElement.classList.remove('error');
    }

    // if (Global.email.length != 0) {
    //   if (
    //     !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Global.email) &&
    //     isValid
    //   ) {
    //     document
    //       .querySelector('#register_screen #email')
    //       .parentElement.classList.add('error');
    //     document.querySelector('.errorSec').innerHTML = 'Invalid Email.';
    //     isValid = false;
    //   } else if (
    //     /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Global.email)
    //   ) {
    //     document
    //       .querySelector('#register_screen #email')
    //       .parentElement.classList.remove('error');
    //   }
    // } else if (isValid) {
    //   document
    //     .querySelector('#register_screen #email')
    //     .parentElement.classList.add('error');
    //   document.querySelector('.errorSec').innerHTML = 'Invalid Email.';
    //   isValid = false;
    // }

    // if (Global.location.length == 0 && isValid) {
    //   document
    //     .querySelector('#register_screen #location')
    //     .parentElement.classList.add('error');
    //   document.querySelector('.errorSec').innerHTML = 'Invalid Location.';
    //   isValid = false;
    // } else {
    //   document
    //     .querySelector('#register_screen #location')
    //     .parentElement.classList.remove('error');
    // }
    // if (Global.IGHandle.length == 0 && isValid) {
    //   document
    //     .querySelector('#register_screen #ig_handle')
    //     .parentElement.classList.add('error');
    //   document.querySelector('.errorSec').innerHTML = 'Invalid IG Handle.';
    //   isValid = false;
    // } else {
    //   document
    //     .querySelector('#register_screen #ig_handle')
    //     .parentElement.classList.remove('error');
    // }
    if (!document.querySelector('#terms_accept').checked) {
      document.querySelector('.errorSec').innerHTML =
        'Please accept the T&C to procced.';
      isValid = false;
    }

    if (!isValid) {
      this.errorTO && clearTimeout(this.errorTO);
      document.querySelector('.errorSec').classList.add('active');
      this.errorTO = setTimeout(() => {
        document.querySelector('.errorSec').classList.remove('active');
      }, 1000);
    }

    return isValid;
  }

  showNextScreen() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'ShowAvatarSelection',
        },
      },
    });
  }
  hideScreen() {
    document.querySelector('#register_screen').classList.remove('active');
  }
}
